export default {
	state: {
		uid: {}
	},
	getters: {
		"uid": state => state.uid
	},
	mutations: {
		setUid(state, payload) {
			state.uid = payload
		}
	},
	actions: {
		atualizarEstadoUid({ commit }, payload) {
			commit('setUid', payload)
		}
	}
};